export default __webpack_public_path__ + "static/media/caret-inactive.29eb5adb.svg";